import { GraphQLList, GraphQLObjectType } from 'graphql';

import { TypeNames } from '../../types';

import { PrivacyValue } from './UserManagePrivacySettings';

const AllowedPrivacyValue = new GraphQLList(PrivacyValue);

const UserManagePrivacySettingsAllowed = new GraphQLObjectType({
	fields: {
		name: { type: AllowedPrivacyValue },
		nickname: { type: AllowedPrivacyValue },
		jobTitle: { type: AllowedPrivacyValue },
		department: { type: AllowedPrivacyValue },
		organization: { type: AllowedPrivacyValue },
		location: { type: AllowedPrivacyValue },
		zoneinfo: { type: AllowedPrivacyValue },
		email: { type: AllowedPrivacyValue },
		phoneNumber: { type: AllowedPrivacyValue },
		picture: { type: AllowedPrivacyValue },
		teamType: { type: AllowedPrivacyValue },
	},
	name: TypeNames.PRIVACY_VALUES_CONFIG,
	description: 'User privacy settings allowed values',
});

export default UserManagePrivacySettingsAllowed;
